export const EXTENSION_TYPE_NAME = 'da-muro';
